import { EEmirAliciTipi, EMesajAltTipi, EMesajTipi, EUcNokta } from 'src/types/components/socket.type';
import { TSocketMessageType } from 'src/types/mixed.type';
import JSONbig from 'json-bigint';
import { LRCState } from '../components/LRC/lrc.config';
import { isBigInt } from './parse-bigint.helper';

let socket: WebSocket | undefined;

const JSONbigAlways = JSONbig({ useNativeBigInt: true });

export const createConnection = (address: string, socketCallback: (socketStatus: boolean) => void) => {
  if (socket === undefined) {
    socket = new WebSocket(address);
    // socket = new WebSocket(urlsConfig.socketUrl, 'echo-protocol');

    socket.onerror = () => {
      socketCallback(false);
    };

    socket.onopen = () => {
      socketCallback(true);
    };

    socket.onclose = () => {
      socketCallback(false);
    };
  }
};

export const disconnect = () => {
  if (socket) {
    socket.close(1000, 'reconnect');
    socket = undefined;
  }
};

export const listenSocket = (callback: (event: any) => void) => {
  if (socket) {
    socket.onmessage = callback;
  }
};

export const sendMessage = (message: any, isJSON: boolean = true) => {
  setTimeout(() => {
    if (socket) {
      if (isJSON) {
        socket.send(
          JSONbigAlways.stringify(message, (key, value) => {
            if (isBigInt(value) && key !== 'sidc') {
              return BigInt(value);
            }
            return value;
          }),
        );
      } else {
        socket.send(message);
      }
    }
  }, 1000);
};

export const connectionRequest = (gameId: number) => {
  const msg: TSocketMessageType = {
    mesajTipi: EMesajTipi.GENEL,
    mesajAltTipi: EMesajAltTipi.BAGLANTI_TALEBI,
    icerik: {
      istemciTipi: EUcNokta.ISTEMCI_ETECUBE,
      uygulamaSekli: 2, // Mock for now
      tur: 1,
      emirAliciTipi: EEmirAliciTipi.ETMEN,
      emirIcerigi: {},
      emirId: -1,
      icraEdecekEtmenId: -1,
      icraZamani: 0,
      icraZamaniTipi: 1,
      kontrolTipi: -1,
      istemciEtmenId: -1,
      userRole: '6c741fa4-fbec-4b3d-917b-4721f38d1839',
    },
    oyunId: gameId,
  };
  sendMessage(msg);
};

export const connectToFederation = (gameId: number, icerik: LRCState | {}, status: 'connect' | 'disconnect') => {
  const msg: TSocketMessageType = {
    oyunId: gameId,
    mesajTipi: EMesajTipi.HLA,
    mesajAltTipi: status === 'connect' ? EMesajAltTipi.LRC_RTI_BAGLAN : EMesajAltTipi.LRC_RTI_BAGLANTI_KES,
    icerik,
  };

  sendMessage(msg);
};

export const closeSocketConnection = (gameId: number) => {
  const msgStop: TSocketMessageType = {
    mesajTipi: 1,
    mesajAltTipi: 10,
    icerik: {
      istemciTipi: 5,
      uygulamaSekli: 2, // Mock for now
      tur: 1,
      emirAliciTipi: 1,
      emirIcerigi: {},
      emirId: -1,
      icraEdecekEtmenId: -1,
      icraZamani: 0,
      icraZamaniTipi: 1,
      kontrolTipi: -1,
      istemciEtmenId: -1,
      userRole: '6c741fa4-fbec-4b3d-917b-4721f38d1839',
    },
    oyunId: gameId || 0,
  };
  sendMessage(msgStop);
};
